import { render, staticRenderFns } from "./running-record-summary.vue?vue&type=template&id=0e97dd24&scoped=true"
import script from "./running-record-summary.vue?vue&type=script&lang=ts"
export * from "./running-record-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97dd24",
  null
  
)

export default component.exports